var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"1em","width":"1em","viewBox":"0 0 48 48","fill":"currentColor"}},[_c('path',{attrs:{"d":"m18.75 36-2.15-2.15 9.9-9.9-9.9-9.9 2.15-2.15L30.8 23.95Z","fill":"currentColor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }